import { merchantApi } from '@/config/axios'

export interface BConsoleBindingVO {
  consoleId: string
  subjectId: string
  subjectName?: string
  status: 'ACTIVE' | 'PENDING' | 'DISABLED' | string
  homePath: string
  title: string
}

export interface BConsoleBindingsResp {
  bindings: BConsoleBindingVO[]
}

export interface BConsoleEnterResp {
  consoleId: string
  subjectId: string
  subjectName?: string
  homePath: string
  title: string
}

export function listBConsoleBindings() {
  return merchantApi.get<BConsoleBindingsResp>({ url: '/merchant-api/b/console/bindings' })
}

export function enterBConsole(data: { consoleId: string; subjectId: string }) {
  return merchantApi.post<BConsoleEnterResp>({ url: '/merchant-api/b/console/enter', data })
}
